import { useNonFavouritedExchanges } from './useNonFavouritedExchanges';

export const useNonFavouritedExchangeCount = () => {
  return useNonFavouritedExchanges().length;
};
